import axios from "axios";

const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const API = isLocal ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
